module.exports = __webpack_public_path__ + "img/Brunei.fd5bdf5f.png";